import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import styles from './styles.module.css';
import TopContainer from './topContainer';
import BottomContainer from './bottomContainer';
import { getBillDetailsById } from '../../actions';
import PropTypes from 'prop-types';

const DetailBill = ({
  getBillDetailsById,
  billHistoryState: {
    singleBillData,
    isSingleBillDataLoading,
    isSingleBillDataError,
    getSingleBillDataError,
  },
}) => {
  const { billId } = useParams();

  useEffect(() => {
    if (billId) {
      getBillDetailsById(billId);
    }
  }, [billId, getBillDetailsById]);

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <TopContainer />
      </div>
      <div className={styles.bottomContainer}>
        <BottomContainer
          billData={singleBillData}
          isLoading={isSingleBillDataLoading}
          isError={isSingleBillDataError}
          error={getSingleBillDataError}
        />
      </div>
    </div>
  );
};

DetailBill.propTypes = {
  getBillDetailsById: PropTypes.func.isRequired,
  billHistoryState: PropTypes.shape({
    singleBillData: PropTypes.object,
    isSingleBillDataLoading: PropTypes.bool,
    isSingleBillDataError: PropTypes.bool,
    getSingleBillDataError: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  billHistoryState: state.billHistoryState,
});

const mapDispatchToProps = {
  getBillDetailsById,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailBill);
